// ** React Imports
import React, { useState } from 'react'

// ** MUI Imports
import { Box, Button, Tab, Tabs, Typography } from '@mui/material'
import RefreshIcon from '@mui/icons-material/Refresh'

// ** Components
import WorkspacePrices from './components/WorkspacePrices'
import GcpPrices from './components/GcpPrices'

// ** Utils
import moment from 'moment'

const GooglePricing = () => {
  const [tab, setTab] = useState('workspace')
  const [refreshKey, setRefreshKey] = useState(0)
  const [fetchedAt, setFetchedAt] = useState(null)

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2, mb: 3 }}>
        <Box sx={{ flexGrow: 1 }}>
          <Typography variant='h5'>Google Prices</Typography>
          <Typography variant='body2' color='text.secondary'>
            Live prices from the Cloud Channel API (Workspace, Gemini and add-ons) and the Cloud Billing Catalog API
            (Google Cloud).
            {fetchedAt ? ` Data from ${moment(fetchedAt).fromNow()}.` : ''}
          </Typography>
        </Box>
        <Button variant='outlined' size='small' startIcon={<RefreshIcon />} onClick={() => setRefreshKey(k => k + 1)}>
          Refresh from Google
        </Button>
      </Box>

      <Tabs value={tab} onChange={(e, value) => setTab(value)} sx={{ mb: 4 }}>
        <Tab value='workspace' label='Workspace & add-ons' />
        <Tab value='gcp' label='Google Cloud' />
      </Tabs>

      {/* Both stay mounted so switching tabs keeps the filters */}
      <Box sx={{ display: tab === 'workspace' ? 'block' : 'none' }}>
        <WorkspacePrices refreshKey={refreshKey} onFetched={tab === 'workspace' ? setFetchedAt : undefined} />
      </Box>
      <Box sx={{ display: tab === 'gcp' ? 'block' : 'none' }}>
        <GcpPrices refreshKey={refreshKey} onFetched={tab === 'gcp' ? setFetchedAt : undefined} />
      </Box>
    </Box>
  )
}

export default GooglePricing
